import { render, staticRenderFns } from "./card-rev.vue?vue&type=template&id=ad9b4498&"
import script from "./card-rev.vue?vue&type=script&lang=js&"
export * from "./card-rev.vue?vue&type=script&lang=js&"
import style0 from "./card-rev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports